import Environment from '../constants/Environment';
import TrackingEndpoint from '../constants/TrackingEndpoint';
import {getEnvironment} from './getEnvironment';

const ENDPOINT_BY_ENVIRONMENT = {
  [Environment.DEVELOPMENT]: TrackingEndpoint.STAGING,
  [Environment.STAGING]: TrackingEndpoint.STAGING,
  [Environment.SANDBOX]: TrackingEndpoint.SANDBOX,
  [Environment.PRODUCTION]: TrackingEndpoint.PRODUCTION,
};

export const getTrackingEndpoint = (providedEnv?: Environment): string => {
  const environment =
    providedEnv || getEnvironment(typeof window === 'undefined' ? undefined : window);

  return `${ENDPOINT_BY_ENVIRONMENT[environment]}/graphql`;
};

export const getTrackingIdEndpoint = (providedEnv?: Environment): string => {
  const environment =
    providedEnv || getEnvironment(typeof window === 'undefined' ? undefined : window);

  return `${ENDPOINT_BY_ENVIRONMENT[environment]}/tid`;
};
